<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="detail_dialog" top="5vh" width="800px" :fullscreen="isExpand"
    :show-close="false" :before-close="handleClose" :close-on-click-modal="false" :append-to-body="true" :close-on-press-escape="false">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>选择适配品牌</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <div class="content">
      <el-input placeholder="搜索" v-model="searchBrandName" @input="handleSearch" clearable>
        <el-button slot="prepend" icon="el-icon-search"></el-button>
      </el-input>
      <div class="brand-list-wrapper" @scroll="handleScroll" ref="brandListWrapper">
        <el-checkbox-group v-model="checkedBrands">
          <el-checkbox v-for="(brand, index) in brandList" @change="handleCheckedBrand($event, index, brand)" :label="brand.id" :key="brand.id" :disabled="brand.disabled" style="display: block;">{{brand.name}}</el-checkbox>
        </el-checkbox-group>
        <!-- 加载更多状态 -->
        <div v-if="loading" class="loading-more">
          <span>加载中...</span>
        </div>
      </div>
      <el-checkbox v-model="adaptedBrandType" :disabled="!!disabledBrands.length">通用</el-checkbox>
    </div>
    <div class="dialog-footer" style="padding-top: 10px; text-align: right;">
      <el-button plain @click="handleClose">取消</el-button>
      <el-button type="primary" @click="sure">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getBrandPageList } from '@/api/goods';
export default {
  data () {
    return {
      dialogVisible: false,
      isExpand: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      brandList: [],
      selectedLists: [],
      disabledBrands: [],
      checkedBrands: [],
      searchBrandName: '',
      page: {
        pageNum: 1,
        pageSize: 50,
      },
      loading: false,
      hasMore: true,
      total: 0,
      adaptedBrandType: false,
    };
  },
  watch: {
    adaptedBrandType (v) {
      if (v) {
        this.checkedBrands = [];
        this.selectedLists = [];
      }
    },
    dialogVisible (v) {
      if (v && !this.brandList.length) {
        this.handleSearch();
      }
    },
    disabledBrands: {
      handler (v) {
        if (!v.length) {
          this.brandList = this.brandList.map(item => ({...item, disabled: false}));
        } else {
          this.brandList = this.brandList.map(item => ({
            ...item,
            disabled: v.includes(item.id),
          }));
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleClose () {
      this.dialogVisible = false;
      this.searchBrandName = '';
      this.checkedBrands = [];
      this.selectedLists = [];
      this.disabledBrands = [];
      this.adaptedBrandType = false;
      this.handleSearch();
    },
    sure () {
      const finallySelected = [...new Set(this.selectedLists)];
      this.$emit('saveDeviceBrand', {selectedLists: finallySelected, adaptedBrandType: this.adaptedBrandType});
      this.handleClose();
    },
    handleSearch () {
      this.resetPagination();
      this.queryList();
      // 防抖处理
      this.$nextTick(() => {
        this.$refs.brandListWrapper.scrollTop = 0;
      });
    },
    handleCheckedBrand (checked, index, brand) {
      if (checked) {
        this.selectedLists.push(this.brandList[index]);
        this.adaptedBrandType = false;
      } else {
        this.selectedLists = this.selectedLists.filter(item => item.id !== brand.id);
      }
    },
    async queryList () {
      if (this.loading) return;
      this.loading = true;
      try {
        const { body } = await getBrandPageList({
          nameOrShortName: this.searchBrandName,
          enableFlag: true,
          orderBy: [
            {
              orderByProperty: 'createTime',
              orderByType: 'ASC',
            },
          ],
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
        });

        const newList = (body?.list || []).map(item => ({
          ...item,
          disabled: this.disabledBrands.includes(item.id),
        }));
        // 首次加载或搜索时替换数据，否则追加数据
        if (this.page.pageNum === 1) {
          this.brandList = newList;
        } else {
          this.brandList = [...this.brandList, ...newList];
        }

        this.total = body?.total || 0;
        this.hasMore = this.brandList.length < this.total;
      } finally {
        this.loading = false;
      }
    },

    loadMore () {
      if (!this.hasMore || this.loading) return;
      this.page.pageNum++;
      this.queryList();
    },

    handleScroll (e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      // 当滚动到距离底部10px时加载更多
      if (scrollHeight - scrollTop - clientHeight < 10) {
        this.loadMore();
      }
    },

    // 重置分页信息
    resetPagination () {
      this.page.pageNum = 1;
      this.hasMore = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.detail_dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }

  .content {
    padding: 0 10px;
  }

  .brand-list-wrapper {
    max-height: 55vh;
    overflow-y: auto;
    padding: 10px 0;
    margin: 10px 0;
  }

  .loading-more {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    color: #999;
  }

  .no-more {
    text-align: center;
    padding: 10px 0;
    color: #999;
  }
}
</style>
